module.exports = __webpack_public_path__ + "img/status-ERROR-icon.93ac7efe.svg";